import { useSelector } from 'react-redux';
import TrialNotifRow from './TrialNotifRow';
import UtilDate from '../../utils/UtilDate';
import { useTranslation } from 'react-i18next';
import UserActions from '../../actions/UserActions';

const MainLayoutTrialNotif = () => {
  const { t } = useTranslation();

  const activeUntilDate = useSelector((state) => {
    return state?.currentUser?.activeUntilDate;
  });

  const statusClient = useSelector((state) => {
    return state.currentUser?.statusClient;
  });

  const isTrial = statusClient === UserActions.STATUS.TRIAL;

  const trialDaysLeft = Math.abs(
    UtilDate.getDiffDaysCount(UtilDate.getDate(activeUntilDate))
  );

  const dayLabel =
    trialDaysLeft === 1 ? t('WORD_DAY_LEFT_TRIAL') : t('WORD_DAYS_LEFT_TRIAL');

  if (!isTrial) {
    return null;
  }
  return (
    <TrialNotifRow
      title={`${t('WORD_YOU_HAVE')} ${trialDaysLeft} ${dayLabel}`}
      btnLabel={t('WORD_BUY')}
      path="/settings/package_change"
    />
  );
};

export default MainLayoutTrialNotif;
